<template>
    <div class="app-main">
        <!-- 顶部导航组件 -->
        <main-header></main-header>
        <!-- 导航菜单组件 -->
        <main-navbar></main-navbar>
        <!-- 主体内容部分 -->
        <div class="main-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import MainHeader from './main_components/header.vue';
import MainNavbar from './main_components/navbar.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';

export default {
    components: {
        MainHeader,
        MainNavbar
    },
    data() {
        return {
            error1: [
                [], // 0占位,无意义
                // 1模温机(KH54401A)
                ['三厢电源故障', '媒体不足', '泵浦过载', '电热超温', '出媒感温故障', '温度过高', '温度过低', '数据出错', '温差过大', '加热失效', '冷却失效', '回媒感温故障', '机组需维护', '更换加热接触器', '更换用油', '更换冷却接触器'],
                // 2三机一体(DF879500A)
                ['EPROM错误', '逆相', '干燥(再生风机、转轮马达)过载', '输送风机过载', '上限温度报警（干燥）', '温度探头故障（干燥）', 'DH输送异常', 'NO.1输送异常', 'NO.2输送异常', '禁用', '电热超温', '旁通阀限位异常', '干燥加热管断线', '再生加热管断线', '上限温度报警（再生）', '温度探头故障（再生）'],
                // 3冷水机(SF306000A)
                ['1#压缩机高压', '1#压缩机低压', '1#压缩机过载', '水位故障', '流量不足', '冷冻泵过载', '冷却过载', '防冻故障', '三厢电源故障', '温度过低', '超温停机', '温度探头断路', '温度探头短路', '1#压缩机电流过高', '冷冻电流过高', '冷却电流过高'],
                // 4压缩空气干燥机(D-100)
                ['干燥温度感应器线断', '回气温度感应器线断', '温度高报警', '温度低报警', '压力高报警', '压力低报警', '压力感应器线断', '露点感应器线断', '温度过高报警（超温保护器动作）', '压缩空气压力低报警', '加热失效报警', '干燥温度校准错误', '回气温度校准错误', '压力校准错误', '露点校准措误', ''],
                // 5传送带
                ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                // 6自动供料控制器
                ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                // 7机械手(TRC-1100)
                ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                // 8注塑机(JSU)
                ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                // 9TMC温控箱
                ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                // 10干燥机(HC-100)
                ['电源缺相', '电源逆向', 'PT100感应器异常', '加热异常', '风机过载', '过热超温', '温度下限报警', '温度上限报警', 'PT100校准错误', '', '', '', '', '', '', ''],
                // 11占位,无意义
                [],
                // 12注塑机(KLS)
                [],
                // 13机械手(TRC-990)
                [],
                // 14三机一体(SF879500A)
                ['EPROM错误', '逆相', 'DH输送异常', 'NO.1输送异常', 'NO.2输送异常', '禁用', '再生风机过载', '干燥风机过载', '输送风机过载', '再生EGO超温', '干燥EGO超温', '禁用', '转轮异常', '再生加热管断线', '干燥加热管断线', '禁用'],
                // 15占位,无意义
                [],
                // 16占位,无意义
                [],
                // 17占位,无意义
                [],
                // 18占位,无意义
                [],
                // 19占位,无意义
                [],
                // 20模具
                ['模内检测不良品输入', '模具表面温度异常', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                // 21瓶盖检测自动化
                ['机器人1真空失败', '机器人2真空失败', '设备门打开', '急停状态', '机器人2产品异常脱落', '', '', '', '', '', '', '', '', '', '', '']
            ],
            error2: [
                [], // 0占位,无意义
                // 1模温机(KH54401A)
                ['进水水压低', '禁用', '增压泵过载', '首次温度过高', '首次温度过低', '系统压力高', '液位高', '', '', '', '', '', '', '', '', ''],
                // 2三机一体(DF879500A)
                ['转轮异常', '回气探头故障', '备用探头故障', '', '', '通讯故障', '露点仪故障', '', '干燥上限温差报警', '再生上限温差报警', '干燥下限温差报警', '再生下限温差报警', '干燥桶缺料', '', '', ''],
                // 3冷水机(SF306000A)
                ['参数异常', '机组需维护', '1#压缩机电流过低', '冷冻电流过低', '冷却电流过低', '超温报警', '2#压缩机高压', '2#压缩机低压', '2#压缩机过载', '2#压缩机电流过高', '2#压缩机电流过低', '冷却水流故障', '排气温度1过高', '排气温度2过高', '', ''],
                // 4压缩空气干燥机(D-100)
                ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                // 5传送带
                ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                // 6自动供料控制器
                ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                // 7机械手(TRC-1100)
                ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                // 8注塑机(JSU)
                ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                // 9TMC温控箱
                ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                // 10干燥机(HC-100)
                ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                // 11占位,无意义
                [],
                // 12注塑机(KLS)
                [],
                // 13机械手(TRC-990)
                [],
                // 14三机一体(SF879500A)
                ['再生探头故障', '干燥探头故障', '回气探头故障', '再生温度过高', '首次再生温度高', '干燥温度过高', '首次干燥温度高', '露点计故障', '再生温度过低', '首次再生温度低', '干燥温度过低', '首次干燥温度低', '禁用', '冷却探头故障', '机组需维护', '更换干燥加热接触器'],
                // 15占位,无意义
                [],
                // 16占位,无意义
                [],
                // 17占位,无意义
                [],
                // 18占位,无意义
                [],
                // 19占位,无意义
                [],
                // 20模具
                [],
                // 21瓶盖检测自动化
                ['运行周期超时', '复位失败', '复位完成', '上料轴报警', '传送轴报警', '机器人2抓取失败', '气压异常', '机器人2报警', '机器人1报警', '机器人2网络断开', '机器人1网络断开', '机器人2停止', '机器人1停止', 'PLC网络断开', '视觉网络断开', '过渡位置产品未拿走']
            ]
        };
    },
    mounted() {
        this.getAlarms();
        let inter = setInterval(() => {
            this.getAlarms();
        }, 5000);
        this.$once('hook:beforeDestroy', () => {
            clearInterval(inter);
        });
    },
    methods: {
        // 获取最近报警信息
        getAlarms() {
            Axios.get(AxiosUrl.alarm.current, {
                params: {
                    cid: this.$store.state.user.cid
                }
            }).then(res => {
                if (res.data.code == 200) {
                    res.data.data.forEach(item => {
                        let errors = this[`error${item.node}`][item.kind].filter((subitem, index) => {
                            return ((item.err >> index) & 1) == 1;
                        });
                        this.$Notice.error({
                            title: `报警--${item.name}`,
                            desc: errors.join(',')
                        });
                    });
                }
            });
        }
    }
};
</script>
<style lang="less">
.app-main {
    height: 100%;
}
.main-wrap {
    padding: 153px 10px 54px 110px;
}
.web-view {
    height: 100%;
    overflow-y: scroll;
}
</style>




// WEBPACK FOOTER //
// src/views/Main.vue